
import { defineComponent, ref, computed, onMounted, watch } from 'vue';
import { usePopupStore } from '@/store/popup'

export default defineComponent({
  components: {
  },
  props:{
  },
  setup(props, {emit}) {
    const popupStore = usePopupStore();
    
    const closePopup = () => {
      popupStore.togglePopup('joinFail', false);
    }

    const handleConfirmClick = async (): Promise<void> => {
      closePopup();
    }

    onMounted(() => {
    });

    return {
      closePopup,
      handleConfirmClick
    };
  },
});
